import React from 'react';
import { ButtonGroup as MuiButtonGroup } from '@material-ui/core';

const ButtonGroup = props => <MuiButtonGroup {...props} />;

export default ButtonGroup;
